module.exports = __webpack_public_path__ + "img/standRoom.fc597a25.svg";